import Button from "components/Button";
import FactoringCompanySelect from "features/main/Loads/modules/FactoringCompanySelect";
import { IFactoringCompany } from "models/HaulPay";

type SelectFactoringCompanyProps = {
  factoringId: string;
  selectedFactoringCompany?: IFactoringCompany;
  isSubmitting?: boolean;
  handleCompanySelected: (company: IFactoringCompany) => void;
  handleClickNOA: VoidFunction;
  handleSubmitCompany: (company?: IFactoringCompany) => void;
};

export default function SelectFactoringCompany({
  factoringId,
  selectedFactoringCompany,
  isSubmitting = false,
  handleCompanySelected,
  handleClickNOA,
  handleSubmitCompany
}: Readonly<SelectFactoringCompanyProps>) {
  return (
    <div className="flex flex-col flex-1 w-full gap-6 desktop:max-w-4xl desktop:mx-auto">
      <div className="flex items-start gap-4 mobile:flex-col">
        <div className="w-full desktop:flex-1">
          <FactoringCompanySelect
            factoring_id={factoringId}
            company={selectedFactoringCompany}
            onCompanySelected={handleCompanySelected}
          />
        </div>

        <Button
          type="button"
          rounded
          disabled={!selectedFactoringCompany}
          loading={isSubmitting}
          className="mobile:!w-full desktop:!w-64 desktop:!h-14"
          onClick={() => handleSubmitCompany(selectedFactoringCompany)}>
          USE THIS FACTOR
        </Button>
      </div>

      <Button
        type="button"
        className="mt-auto desktop:!w-96 desktop:mx-auto"
        rounded
        onClick={handleClickNOA}>
        I ALREADY HAVE THE NOA
      </Button>
    </div>
  );
}
